// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"352":"49a5e598","389":"3452c161"}[chunkId] + ".chunk.js";
};